import React from 'react'
import {Redirect, Route} from 'react-router-dom'

const PrivateRoute = ({component: Component, componentProps: {...comProps}, authenticated, ...rest}) => {
    return (<Route {...rest} render={routeprops => (
        authenticated ? (
            <Component {...comProps} {...routeprops} />
        ) : (
            <Redirect to={{
                pathname: '/login',
                state: {from: routeprops.location}
            }}/>
        )
    )}/>)
}

export default PrivateRoute



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js